import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import Dropdown from '../../generic/floatingDropdown'

import { BrowserUtils } from '../../../utils/siteUtils'
import { FlexRowDiv } from '../../generic/Basics'
import Error from '../../generic/Error'
import { white, fontSizeSmall, fontSizeXSmall, highlightBlueDark20 } from '../../../constants/principles'
import BasicButton from '../../generic/button'
import { LandingPageNumber, VehiclePageNumber } from '../../../constants'
import IneligibleError from '../../generic/IneligibleError'
import TrimChangeModal from '../../vehicleDetails/TrimChangeModal'
import Mileage from './Mileage'

const onChangeYMM = ({ globalState, year, make, model, onChange, isYear, isMake, isModel, urlState }) => {
  const { prefetchYearStart, prefetchYearLimit } = globalState.environment
  const getLink = (displayName, urlState, isLinksPage, nohashforce, index) => {
    if (nohashforce && isYear && (index < prefetchYearStart || index >= prefetchYearStart + prefetchYearLimit)) return null
    const newObject = { displayName }
    urlState = urlState || (isModel && { p: VehiclePageNumber })
    const prefix = isLinksPage && !isModel ? '/links' : ''
    const nohash = nohashforce || isLinksPage ? true : false
    return prefix + BrowserUtils.getUrlStateLink({ year: isYear ? newObject : year, make: isMake ? newObject : make, model: isModel ? newObject : model, urlState }, nohash)
  }
  const onChangeNew = e => {
    onChange()
    BrowserUtils.navigateToLink(getLink(e.target.value, { p: LandingPageNumber, vin: null, displayYMM: true, x: urlState && urlState.x }))
  }
  return { getLink, onChange: onChangeNew }
}
const updateTrim = (updateVehicleProp, trim) => {
  updateVehicleProp('style', trim)
}

// URL State is CLEARED onChange - new selection - it MIGHT be better to keep them, why would user do stuff and come back and change
export default ({
  globalState,
  years,
  year,
  makes,
  make,
  models,
  model,
  trim,
  trims = [],
  error,
  onChange,
  isLinksPage,
  isDisabled,
  onClick,
  isAdmin,
  urlState,
  updateVehicleProp,
  isIneligible,
  kbbUrl,
  setShowModal,
  updateGlobalState,
  isDigitalRetail,
  isCobrandDR,
  mileage,
  isAssigned,
  ...props
}) => {
  const [inputMileage, setInputMileage] = useState(mileage)
  const isIneligibleVehiclesEnabled = globalState && globalState.isIneligibleVehiclesEnabled
  const nextDisabled = (trim && isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)) || ((isIneligibleVehiclesEnabled ? !isAssigned : true) && inputMileage > 300000)
  const showErrorMessage = !trim || !year || !make || !model
  const offerCode = props.offerCode
  const isOfferCodeTcOffer = offerCode.toUpperCase() === 'TC'

  const onClickContinue = e => {
    onClick(e, false, !(globalState.plate && globalState.state))
  }
  const handleMileage = newValue => {
    if (!isNaN(newValue)) {
      setInputMileage(newValue)
    }
  }

  const onClickInput = e => {
    updateGlobalState({ isIneligibleYear: false, fireAnalytics: 'first_trade_in_start' })
  }

  useEffect(() => {
    const handleUp = event => {
      if (event.target.id !== 'make-model-year-entry') {
        return
      }
      const { keyCode } = event

      if (keyCode === 9) {
        updateGlobalState({ isIneligibleYear: false, fireAnalytics: 'first_trade_in_start' })
      }
    }

    window.addEventListener('keyup', handleUp)
    return () => window.removeEventListener('keyup', handleUp)
  }, [updateGlobalState])

  return (
    <>
      <StyledContainer>
        <StyledYMDiv>
          <StyledYMTextDiv>
            <Dropdown
              id="make-model-year-entry"
              testId={'bi-dr-ymm-year'}
              label="Year"
              fullWidth={true}
              backgroundColor={white}
              disabled={isDisabled}
              options={years}
              {...onChangeYMM({ globalState, year, make, model, isYear: true, onChange, urlState })}
              currentValue={year}
              isError={!year && error}
              isLinksPage={isLinksPage}
              onClick={onClickInput}
            />
          </StyledYMTextDiv>
          <StyledYMMakeDiv>
            <Dropdown
              testId={'bi-dr-ymm-make'}
              fullWidth={true}
              label="Make"
              backgroundColor={white}
              disabled={isDisabled}
              options={makes}
              {...onChangeYMM({ globalState, year, make, model, isMake: true, onChange, urlState })}
              currentValue={make}
              isError={!make && error}
              isLinksPage={isLinksPage}
            />
          </StyledYMMakeDiv>
        </StyledYMDiv>
        <FullWidth>
          <Dropdown
            testId={'bi-dr-ymm-model'}
            fullWidth={true}
            label="Model"
            backgroundColor={white}
            disabled={isDisabled}
            options={models}
            {...onChangeYMM({ globalState, year, make, model, isModel: true, onChange, urlState })}
            currentValue={model}
            isError={!model && error}
            isLinksPage={isLinksPage}
          />
        </FullWidth>
        <FullWidth>
          <Dropdown
            testId={'bi-dr-ymm-style'}
            fullWidth={true}
            label="Style"
            backgroundColor={white}
            disabled={isDisabled}
            options={trims}
            onChange={e => (props.isProspectSet && trim ? setShowModal(e.target.value) : updateTrim(updateVehicleProp, e.target.value))}
            currentValue={trim}
            isError={(!trim && error) || (trim && isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true))}
            valueProp={'trimId'}
          />
        </FullWidth>
        {(!(trim && isIneligible) || (isIneligibleVehiclesEnabled ? isAssigned : false)) && (
          <FullWidth>
            <Mileage
              handleMileage={handleMileage}
              isDisabled={isDisabled || !trim}
              fullWidth={true}
              isError={!inputMileage && error}
              vin={urlState.vin}
              {...{ isDigitalRetail, kbbUrl, inputMileage, trim, isCobrandDR, isAssigned, isIneligibleVehiclesEnabled }}
              {...props}
            />
          </FullWidth>
        )}
      </StyledContainer>
      {error && !!inputMileage && showErrorMessage && <Error text={'Please provide all required information.'} id={'ymm-error'} isError={true} />}
      {trim && <IneligibleError isError={isIneligible && (isIneligibleVehiclesEnabled ? !isAssigned : true)} vin={urlState.vin} isAssigned={isAssigned} {...{ year, make, model, trim, isDigitalRetail, isAdmin, kbbUrl, isCobrandDR, isOfferCodeTcOffer }} />}
      {!nextDisabled && (
        <StyledButtonDiv>
          <StyledButton data-testid={'bi-btn-continue'} disabled={isAdmin} onClick={e => onClickContinue(e)} isSelected={true}>
            Continue
          </StyledButton>
        </StyledButtonDiv>
      )}
      <TrimChangeModal changeTrim={props.changeTrim} setShowModal={setShowModal} showModal={trims && trims.some(trim => trim.trimId === +props.showModal) && props.showModal} trims={trims} trim={trim} updateGlobalState={updateGlobalState} />
    </>
  )
}

const StyledYMDiv = styled(FlexRowDiv)`
  width: 100%;
`

const StyledContainer = styled(FlexRowDiv)`
  width: 100%;
  flex-wrap: wrap;
`

const FullWidth = styled.div`
  margin-top: 16px;
  width: 100%;
`

const StyledYMTextDiv = styled.div`
  flex-grow: 0.2;
  margin-right: 10px;
`

const StyledYMMakeDiv = styled.div`
  margin-left: 10px;
  flex-grow: 2;
`
const StyledButtonDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  line-height: 26px;
  border-radius: 6px;
  width: 100%;
`
const StyledButton = styled(BasicButton)`
  padding: 10px 14px;
  font-size: ${p => (p.isSelected ? fontSizeSmall : fontSizeXSmall)};
  color: ${p => (p.isSelected ? white : highlightBlueDark20)};
  line-height: 26px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: 100%;
`
